var map = {
	"./access_mode/controller.js": 59722,
	"./slug/controller.js": 88571,
	"src/decidim/admin/controllers/access_mode/controller.js": 59722,
	"src/decidim/admin/controllers/slug/controller.js": 88571
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4629;